import { NgModule } from '@angular/core';
import { NewsfeedTopBannerComponent } from '@component/generic/newsfeed-top-banner/newsfeed-top-banner.component';
import { NewsfeedBottomBannerComponent } from '@component/generic/newsfeed-bottom-banner/newsfeed-bottom-banner.component';
import { SharedModule } from './shared.module';
import { CreateEntryButtonComponentModule } from '@component/generic/create-entry-button/create-entry-button.module';

@NgModule({
  declarations: [NewsfeedTopBannerComponent, NewsfeedBottomBannerComponent],
  imports: [SharedModule, CreateEntryButtonComponentModule],
  exports: [NewsfeedTopBannerComponent, NewsfeedBottomBannerComponent],
})
export class NewsfeedBannerModule {}
